import { render } from "./former.html?vue&type=template&id=d262a4d4&scoped=true&ts=true&external"
import script from "./Former.vue?vue&type=script&lang=ts"
export * from "./Former.vue?vue&type=script&lang=ts"

import "./Former.vue?vue&type=style&index=0&id=d262a4d4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d262a4d4"]])

export default __exports__